import { create } from 'zustand';
import { ItemToReturn } from '@src/models/returns';
import { getWindow } from '@src/utils/general';

interface ErrorQtyReasonStore {
  idsWithErrors: string[];
  showError: boolean;
}

export const useErrorQtyReasonStore = create<ErrorQtyReasonStore>()(() => ({
  idsWithErrors: [],
  showError: false,
}));

export const checkForQtyReasonErrors = (items: ItemToReturn[]) => {
  if (!items || items.length === 0) return false;
  const idList = items
    .filter((lineItem) => lineItem.returnReasonCode === '')
    .map((item) => item.lineItemId);
  useErrorQtyReasonStore.setState({ idsWithErrors: idList });
  if (idList && idList.length > 0) {
    useErrorQtyReasonStore.setState({ showError: true });
  } else {
    useErrorQtyReasonStore.setState({ showError: false });
  }
  const indexOfFirstError = items.findIndex(
    (item) => item.lineItemId === idList?.[0],
  );
  if (indexOfFirstError !== -1) scrollToFirstQtyReasonError(indexOfFirstError);
  return idList?.length > 0;
};

export const onUpdateReason = (itemId: string) => {
  useErrorQtyReasonStore.setState((state) => ({
    idsWithErrors: state.idsWithErrors.filter((id) => id !== itemId),
  }));
};

const scrollToFirstQtyReasonError = (index: number) => {
  const found = getWindow()?.document.querySelectorAll('[data-testid="item"]');
  if (found && found.length > 0) {
    const rect = found[index].getBoundingClientRect();
    const scrollTop = window.pageYOffset + rect.top - 140; // 140 is the header height
    window.scrollTo({
      top: scrollTop,
      behavior: 'smooth',
    });
  }
};

export const emptyQtyReasonErrors = () => {
  useErrorQtyReasonStore.setState({ idsWithErrors: [], showError: false });
};

export const _mockErrorQtyReasonStore = (
  mockedState: Partial<ErrorQtyReasonStore>,
) => useErrorQtyReasonStore.setState((state) => ({ ...state, ...mockedState }));

export const _resetErrorQtyReasonStore = () =>
  useErrorQtyReasonStore.setState(
    { idsWithErrors: [], showError: false },
    true,
  );
